import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

import { Desktop, Mobile } from 'components/MediaQuery/index';

import { WarningInsideBubble } from './content/WarningInsideBubble';
import { DisplayerIcon } from './DisplayerIcon';

/* Constants */
const tooltipId = 'eyewear-bubble';
const reactTooltipClassName = 'ReactTooltipStyleOverride';
const reactTooltipClassNameDesktop = `${reactTooltipClassName} desktop`;
const reactTooltipClassNameMobile = `${reactTooltipClassName} mobile`;

/* Components */
const DesktopWarningWrapper = styled.div`
  height: 205px;
  width: 230px;
`;
const MobileWarningWrapper = styled.div`
  height: 230px;
  width: 200px;
`;

export const BubbleDisplayer: React.FC = () => (
  <>
    <Desktop>
      <a data-cy="eyewear-warning-tooltip-activator" data-for={tooltipId} data-tip="">
        <DisplayerIcon />
      </a>
      <ReactTooltip
        border
        className={reactTooltipClassNameDesktop}
        delayHide={200}
        effect="solid"
        id={tooltipId}
        place="right"
      >
        <DesktopWarningWrapper>
          <WarningInsideBubble />
        </DesktopWarningWrapper>
      </ReactTooltip>
    </Desktop>

    <Mobile>
      <a data-cy="eyewear-warning-tooltip-activator" data-event="click" data-for={tooltipId} data-tip="">
        <DisplayerIcon />
      </a>
      <ReactTooltip
        border
        className={reactTooltipClassNameMobile}
        effect="solid"
        globalEventOff="click"
        id={tooltipId}
        place="top"
      >
        <MobileWarningWrapper>
          <WarningInsideBubble />
        </MobileWarningWrapper>
      </ReactTooltip>
    </Mobile>
  </>
);
